import React from 'react';
import PropTypes from 'prop-types';

import * as Styled from './SocialButton.styled';

const PROVIDERS = {
  facebook: {
    img: 'https://assets.bombas.com/image/upload/v1660852253/frontend/facebook-logo.svg',
    title: 'Facebook'
  }
};

/**
 * A Button for authenticating with various social providers
 */
const SocialButton = ({ provider, onClick, ...props }) => (
  <Styled.SocialButton
    img={PROVIDERS[provider].img}
    onClick={onClick}
    {...props}
  >
    {`Continue with ${PROVIDERS[provider].title}`}
  </Styled.SocialButton>
);

SocialButton.propTypes = {
  /**
   * key of the social provider to display
   */
  provider: PropTypes.oneOf(Object.keys(PROVIDERS)).isRequired,
  /**
   * Callback function to run when the button is clicked
   */
  onClick: PropTypes.func.isRequired
};

SocialButton.defaultProps = {};

export default SocialButton;
